import React from 'react';
import cx from 'classnames';

import { groupMarketTypeInstructions, useSportState } from '@atlas/core';

import { NON_PARAMETRIZED_MARKETS_WITH_NAME } from 'common/constants';
import EventsLoader from 'common/Widgets/Tournament/Tournament/Events/SimpleEvents/EventsLoader';
import SimpleEvents from 'common/Widgets/Tournament/Tournament/Events/SimpleEvents/SimpleEvents';
import useSelectedMarketType from 'hooks/useSelectedMarketType';

const Tournament = ({ headerTitleSplitter = ' ', tournament, withoutFavoriteBtn }) => {
  const { categoryName, name } = tournament;
  const { mainMarketTypes } = useSportState();
  const selectedMarketType = useSelectedMarketType();

  const label = [categoryName, name].filter(Boolean).join(headerTitleSplitter);

  const mainMarketTypesByPeriod = React.useMemo(
    () =>
      groupMarketTypeInstructions(mainMarketTypes, {
        selectedMarketType,
        // TODO: please fix me after migration to tournament APIv2
        tournamentMainTypes: tournament?.sportForm?.mainTypes || tournament.sportForm || [],
      }),
    [mainMarketTypes, tournament, selectedMarketType],
  );

  const activeMarket = React.useMemo(
    () =>
      mainMarketTypes.find(
        ({ id }) =>
          id.toString() === selectedMarketType && !NON_PARAMETRIZED_MARKETS_WITH_NAME.includes(id),
      ),
    [mainMarketTypes, selectedMarketType],
  );

  const mappedMarketOutcomeTypes = React.useMemo(() => {
    const sortedOutcomes = activeMarket?.outcomeTypes?.sort(
      (a, b) => a.orderPosition - b.orderPosition,
    );

    return sortedOutcomes?.map(({ id, shortName }) => (
      <span className="outcome-name" key={id}>
        {shortName}
      </span>
    ));
  }, [activeMarket]);

  const isParametric = activeMarket?.parameterized;
  const outcomeHeaderClassName = cx('outcomes-header', { 'is-parametric': isParametric });

  return (
    <div className="tournament">
      <div className="tournament-header">
        <h3 className="label">{label}</h3>
        <div className={outcomeHeaderClassName}>{mappedMarketOutcomeTypes}</div>
      </div>

      <EventsLoader>
        <SimpleEvents
          mainMarketTypesByPeriod={mainMarketTypesByPeriod}
          withoutFavoriteBtn={withoutFavoriteBtn}
        />
      </EventsLoader>
    </div>
  );
};

export default Tournament;
